<template>
  <v-card class="ma-4">
    <v-toolbar>
      <v-toolbar-title>Theatre Show Admin</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select v-model="year" :items="years" label="School Year" outlined hide-details style="max-width:300px" />
      <v-dialog v-model="newShowDialog" width="400">
        <template #activator="{ on }">
          <v-btn v-on="on">Add Show</v-btn>
        </template>
        <v-card>
          <v-card-title>Add Show</v-card-title>
          <v-card-text>
            <v-text-field v-model="newShowName" label="Name of Show" outlined />
            <v-text-field v-model="newShowShortName" label="Short Name (for URL Link; must be unique)" outlined />
          </v-card-text>
          <v-card-actions>
            <v-btn :disabled="!newShowValid" color="primary" text @click="createNewShow()">Create New Show</v-btn>
            <v-spacer />
            <v-btn text @click="newShowDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table :items="shows" :headers="headers" group-by="name">
      <template #group.header="{ group, isOpen, toggle }">
        <td :colspan="headers.length">
          <v-btn icon small class="mr-2" @click="toggle()">
            <v-icon>fal fa-chevron-circle-{{ isOpen ? 'down' : 'right' }}</v-icon>
          </v-btn>
          <v-chip label outlined class="mr-4" style="min-width:300px" @click="toggle()">{{ group }}</v-chip>
          <v-btn icon small :to="'/theatre/' + getShortName(group)" class="mx-2">
            <v-icon>fal fa-edit</v-icon>
          </v-btn>
          <v-tooltip top>
            <template #activator="{ on }">
              <v-btn v-on="on" icon small class="mx-2" @click="openAddPerformance(group)">
                <v-icon>fal fa-plus-circle</v-icon>
              </v-btn>
            </template>
            <span>Add Performance</span>
          </v-tooltip>
        </td>
      </template>
      <template #item.reserved="{ item }">
        <v-btn :to="'/theatre/tickets/' + item._id">{{ item.reserved }}</v-btn>
      </template>
    </v-data-table>
    <add-performance-dialog v-model="addPerformanceDialog" :show-id="selectedShowId" />
    <!-- <show-dialog /> -->
  </v-card>
</template>
<script>
import { ref, computed, watch, onMounted } from '@vue/composition-api'

export default {
  components: {
    AddPerformanceDialog: () => import('@/components/theatre/addPerformanceDialog')
    // ShowDialog: () => import('@/components/theatre/showDialog')
  },
  setup (props, { root }) {
    const user = computed(() => 'spoof' in root.$store.state.user ? root.$store.state.user.spoof : root.$store.state.user)
    const isLoaded = ref(false)
    const year = ref('2627')
    const years = ref([{ text: '2026-2027 School Year', value: '2627' }])
    const shows = ref([])
    const headers = ref([
      { text: 'Performance Date', value: 'dateStr' },
      { text: 'Seats', value: 'seats' },
      { text: 'Reserved', value: 'reserved' },
      { text: 'Seats Left', value: 'seatsLeft' },
      { text: 'Covenant Student', value: 'Covenant Student' },
      { text: 'Covenant Faculty/Staff', value: 'Covenant Faculty/Staff' },
      { text: 'Community Adult', value: 'Community Adult' },
      { text: 'Community Student/Elder', value: 'Community Student/Elder' }
    ])

    onMounted(() => {
      loadShows()
    })
    watch(year, () => {
      loadShows()
    })

    async function loadShows () {
      const aggregate = [
        { $match: { year: year.value } },
        { $unwind: '$performances' },
        { $addFields: {
          _id: '$performances._id',
          date: '$performances.date',
          seats: '$performances.tickets',
          reserved: '$performances.reserved',
          prices: '$performances.prices',
          seatsLeft: { $subtract: ['$performances.tickets', '$performances.reserved'] }
        } },
        { $sort: { 'performances.date': 1 } }
      ]
      const { data } = await root.$feathers.service('theatre/show').find({ query: { aggregate } })
      shows.value = data.map((row) => {
        const dt = new Date(row.date)
        const date = dt.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
        const time = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' })
        row.dateStr = `${date} at ${time}`
        for (const { label, price, limit } of row.prices) {
          row[label] = `$${price}` + (limit ? ` - ${limit} Ticket Limit` : '')
          const rec = headers.value.find(({ text }) => text === label)
          if (!rec) {
            headers.value.push({ text: label, value: label })
          }
        }
        return row
      })
      isLoaded.value = true
    }

    const newShowDialog = ref(false)
    const newShowName = ref('')
    const newShowShortName = ref('')
    const newShowValid = ref(false)

    watch([newShowName, newShowShortName], async () => {
      if (!isLoaded.value) return
      console.log('Dialog value changed')
      if (!newShowName.value) {
        console.log(`New Show Name is invalid: ${newShowName.value}`)
        newShowValid.value = false
      }
      if (!newShowShortName.value) {
        console.log(`New Show Short Name is invalid: ${newShowShortName.value}`)
        newShowValid.value = false
      } else {
        console.log('Checking for other shows with the same short name')
        const { total } = await root.$feathers.service('theatre/show').find({ query: { year: year.value, $or: [{ closeDate: null }, { closeDate: { $exists: false } }, { closeDate: { $gte: new Date() } }], shortName: newShowShortName.value, $limit: 0 } })
        newShowValid.value = (total === 0)
      }
    })

    async function createNewShow () {
      if (newShowValid.value) {
        const obj = {
          name: newShowName.value,
          shortName: newShowShortName.value,
          year: year.value
        }
        const res = await root.$feathers.service('theatre/show').create(obj)
        if (res) {
          root.$router.push('/theatre/' + res.shortName)
        }
      }
    }

    function getShortName (name) {
      const rec = shows.value.find(({ name: n }) => name === n)
      if (rec) {
        return rec.shortName
      }
      return ''
    }
    const addPerformanceDialog = ref(false)
    const selectedShowId = ref('')
    function openAddPerformance (name) {
      const rec = shows.value.find(({ name: n }) => name === n)
      if (rec) {
        selectedShowId.value = rec._id
        addPerformanceDialog.value = true
      }
    }

    return {
      user,
      isLoaded,
      year,
      years,
      shows,
      headers,
      newShowDialog,
      newShowName,
      newShowShortName,
      newShowValid,
      createNewShow,
      getShortName,
      selectedShowId,
      addPerformanceDialog,
      openAddPerformance
    }
  }
}
</script>
